<template>
  <!-- 设备工况 -->
  <div class="equipments-condition none-height flex-grow-1 d-flex flex-column">

    <!-- 條件查詢 -->
    <div class="selector-container d-flex align-items-start section-container" :class="{ dark: skinType }">
      <SectionTitle style="margin-top:6px;" title="设备工况"></SectionTitle>
      <project-level-selector @selectItem="selectItemListener" levelType="xm" style="margin-right: 1rem">
      </project-level-selector>
      <el-form :inline="true" style="text-align: left" size="small">
        <el-form-item label="通道类型" :class="{ 'light-label': skinType }">
          <el-select v-model="queryForm.type" placeholder="通道类型">
            <el-option v-for="(channel, index) of channelTypes" :key="channel + index" :value="channel"
              :label="channel"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="运行状态" :class="{ 'light-label': skinType }">
          <el-select v-model="queryForm.manufacturer" placeholder="运行状态">
            <el-option v-for="(manufacturer, index) of manufacturerTypes" :key="index" :label="manufacturer"
              :value="index - 1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="exportTable">导出</el-button>
        </el-form-item>
        <el-button type="primary" style="margin-left: 100px;" @click="deviceDetails">设备详情</el-button>
      </el-form>
    </div>
    <el-table size="small" class="energy-table none-height flex-grow-1" :data="tableData" height="0" style="width: 100%"
      :class="{ dark: skinType }" ref="table" stripe :row-class-name="
        (...nu) => {
          return skinType ? 'dark text-white' : '';
        }
      ">
      <el-table-column label="#" type="index" width="60"></el-table-column>
      <el-table-column prop="SBName" label="设备名称"> </el-table-column>

      <el-table-column prop="SBID" label="设备Id"> </el-table-column>

      <el-table-column prop="ModeType" label="通道类型"> </el-table-column>
      <el-table-column prop="TongDaoBiaoShi" label="通道标识">
      </el-table-column>
      <el-table-column prop="Status" label="运行状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status == '离线' ? 'info' : 'success'" :effect="skinType ? 'dark' : 'light'"
            size="mini">
            {{ scope.row.Status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="SendBytes" label="发送字节数"></el-table-column>
      <el-table-column prop="ReceiveBytes" label="接收字节数">
      </el-table-column>
      <el-table-column prop="UpdateTime" label="更新时间" width="160"></el-table-column>
    </el-table>
    <!-- <div
      class="d-flex section-container"
      style="padding: 1rem"
      :class="{ dark: skinType }"
    >
      <el-pagination
        v-if="pageInfo.total"
        :class="{ 'text-white': skinType }"
        style="margin-left: auto"
        background
        layout="total, prev, pager, next"
        :total="pageInfo.total"
        :current-page.sync="pageIndex"
      >
      </el-pagination>
    </div> -->
    <el-dialog  :class="{ 'dark': skinType }" :visible.sync="dialogVisible" top="8%" :title="dialogTitle" @close="handleClose"
      width="50%">
        <div   id="Rectangulartree" class="el-dialog-div">
        </div>
    </el-dialog>
  </div>
</template>
<script>
  import * as echarts from 'echarts';

  import {
    getChannelTypes,
    getEquipsCondition,
    GetSheBeiGongKuangRectangleList,
  } from '@/api/equipments/equipments';
  import { exportExcel } from '@/utils/utils';
  import ProjectLevelSelector from '@/components/utils/project-level-selector.vue';
  import SectionTitle from '@/components/utils/section-title.vue';
  import TurnAskingMixin from '@/mixins/turn-ask';
  import chuliwancheng from '@/components/equipment-operational/components/dialog/chuliwancheng.vue';
  export default {
    name: 'equipments-condition',
    components: {
      chuliwancheng,
      ProjectLevelSelector,
      SectionTitle,
    },
    mixins: [TurnAskingMixin],
    data() {
      return {
        radio: 1,
        dialogTitle: '通讯设备状态',
        dialogVisible: false,
        selectProject: null,
        queryForm: { manufacturer: -1, type: '全部' },
        channelTypes: ['全部'],
        manufacturerTypes: ['全部', '离线', '正常'],
        pageInfo: {
          index: 1,
          size: 10,
          total: 0,
        },
        filterText: '',
        defaultProps: {
          children: 'children',
          label: 'label',
        },
        tableData: [],
        pageIndex: 1,
      };
    },
    watch: {
      queryForm: {
        deep: true,
        handler() {
          if (this.pageIndex !== 1) {
            this.pageIndex = 1;
            return;
          }
          this.requestEquipsCondition();
        },
      },
      // pageInfo: {
      //   deep: true,
      //   handler(newVal, oldVal) {
      //     if (newVal.index !== oldVal.index) {
      //       this.requestEquipsCondition();
      //     }
      //   },
      // },
      selectProject() {
        this.requestEquipsCondition();
      },
    },
    created() {
      // 获取通道名称
      this.requestChanelTypes();
      this.requestEquipsCondition();
    },
    mounted() {

    },
    computed: {
      skinType() {
        return this.$store.getters.skinType;
      },
    },
    methods: {
      getLevelOption() {
        return [
          {
            itemStyle: {
              borderWidth: 0,
              gapWidth: 5
            }
          },
          {
            itemStyle: {
              gapWidth: 1
            }
          },
          {
            colorSaturation: [0.35, 0.5],
            itemStyle: {
              gapWidth: 1,
              borderColorSaturation: 0.6
            }
          }
        ];
      },
      handleClose() {
        this.dialogVisible = false;
      },
      initChart(demoData) {
        this.$nextTick(() => {
          let myChart = echarts.init(document.getElementById('Rectangulartree'));
          let option;
          myChart.setOption(
            (option = {
              title: {
                text: '',
                left: 'center'
              },
              tooltip: {
                formatter: function (info) {
                  var value = info.value;
                  var treePathInfo = info.treePathInfo;
                  var treePath = [];
                  for (var i = 1; i < treePathInfo.length; i++) {
                    treePath.push(treePathInfo[i].name);
                  }
                  return [
                    '<div class="tooltip-title">' +
                    formatUtil.encodeHTML(treePath.join('/')) +
                    '</div>',
                    'Disk Usage: ' + formatUtil.addCommas(value) + 'KB'
                  ].join('');
                }
              },
              series: [
                {
                  name: '复位',
                  type: 'treemap',
                  visibleMin: 300,
                  label: {
                    show: true,
                    formatter: '{b}'
                  },
                  itemStyle: {
                    borderColor: '#fff'
                  },
                  levels: this.getLevelOption(),
                  data: demoData
                }
              ]
            })
          );
          myChart.setOption(option);
        })
      },
      selectItemListener(selectItem) {
        if (selectItem.oType === 'xm') {
          this.selectProject = selectItem;
        }
      },
      currentChangeListener(no) {
        this.pageIndex = no;
      },
      requestChanelTypes() {
        getChannelTypes().then((res) => {
          this.channelTypes = ['全部'].concat(res);
          [this.queryForm.type] = this.channelTypes;
        });
      },
      requestEquipsCondition() {
        if (!this.selectProject) {
          return;
        }
        getEquipsCondition({
          ProjectIdStr: this.selectProject.IdStr,
          ModeType: this.queryForm.type === '全部' ? null : this.queryForm.type,
          Status:
            this.queryForm.manufacturer === -1
              ? null
              : this.queryForm.manufacturer,
          isExport: null,
          Page: this.pageIndex,
          Rows: this.pageInfo.size,
        }).then((res) => {
          if (res === null) {
            this.tableData = [];
            this.pageInfo.total = 0;
            return;
          }
          this.pageInfo.total = res.total || 0;
          this.tableData = res.list || res || [];
        }).catch(() => {
          this.tableData = [];
          this.pageInfo.total = 0;
        }).then(() => {
          // this.turnAsking({
          //   routeName: this.routeName,
          //   nowRouteName: this.$route.name,
          //   func: this.requestEquipsCondition,
          // }, 5000);
        });
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      onSubmit() {
        this.requestEquipsCondition();
      },
      exportTable() {
        exportExcel(this.$refs.table.$el);
      },
      deviceDetails() {
        this.dialogVisible = true;
        GetSheBeiGongKuangRectangleList({})
          .then((res) => {
            let demoData = res.list;
            this.initChart(demoData);
          })
          .catch(() => {
            // this.initChart( );
          });
      }
    },
  };
</script>
<style scoped>

</style>
<style lang="scss" scoped>
  .el-dialog-div {
    height: 60vh;
    overflow: auto;
    /* background-color: #223388; */
  }

</style>